import React from 'react';
import { CheckCircle } from 'lucide-react';
export function ThankYouConfirmation() {
  return <>
      <div className="w-20 h-20 bg-storm-red/10 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-3477">
        <CheckCircle className="w-10 h-10 text-storm-red" data-id="element-3478" />
      </div>

      <h1 className="text-5xl text-ink mb-6" data-id="element-3479">
        Your Free Trial Request Has Been Received
      </h1>

      <p className="text-xl text-gray-warm mb-12 leading-relaxed" data-id="element-3480">
        Storm Taekwondo will contact you soon to confirm the best class time and
        next steps. We look forward to meeting you!
      </p>
    </>;
}